/**
 * Гвард позволяет вводить только целые и дробные числа
 * @param value
 */
export var floatAndIntGuard = function floatAndIntGuard(value) {
  var t = 0;
  return value.replace(/[^0-9,.]/g, '').replace(/[,.]/, '.').replace(/[,.]/g, function (m) {
    return ++t > 1 ? '' : m;
  });
};